import React, { useState } from 'react';
import { leadCaptureFields } from '../data/questions';

function LeadCapture({ onComplete, initialData }) {
  const [formData, setFormData] = useState(initialData || {});
  const [errors, setErrors] = useState({});

  const handleChange = (fieldId, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldId]: value
    }));
    // Clear error when user starts typing
    if (errors[fieldId]) {
      setErrors(prev => ({
        ...prev,
        [fieldId]: ''
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    leadCaptureFields.forEach(field => {
      if (field.required && !formData[field.id]) {
        newErrors[field.id] = `${field.label} is required`;
      }
      // Email validation
      if (field.type === 'email' && formData[field.id]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData[field.id])) {
          newErrors[field.id] = 'Please enter a valid email address';
        }
      }
    });
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    
    if (Object.keys(newErrors).length === 0) {
      onComplete(formData);
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="lead-capture">
      <div className="container">
        <div className="form-container">
          <h2 className="form-title">Let's Get Started</h2>
          <p className="form-subtitle">
            First, tell us a bit about yourself so we can personalize your results.
          </p>

          <form onSubmit={handleSubmit} className="capture-form">
            {leadCaptureFields.map(field => (
              <div key={field.id} className="form-group">
                <label htmlFor={field.id} className="form-label">
                  {field.label}
                  {field.required && <span className="required">*</span>}
                </label>

                {field.type === 'text' || field.type === 'email' ? (
                  <input
                    type={field.type}
                    id={field.id}
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    className={`form-input ${errors[field.id] ? 'error' : ''}`}
                  />
                ) : field.type === 'select' ? (
                  <select
                    id={field.id}
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    className={`form-select ${errors[field.id] ? 'error' : ''}`}
                  >
                    <option value="">-- Select --</option>
                    {field.options.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                ) : field.type === 'textarea' ? (
                  <textarea
                    id={field.id}
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    rows="4"
                    className={`form-textarea ${errors[field.id] ? 'error' : ''}`}
                  />
                ) : null}

                {errors[field.id] && (
                  <span className="error-message">{errors[field.id]}</span>
                )}
              </div>
            ))}

            <button type="submit" className="submit-button">
              Continue to Assessment
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LeadCapture;
